var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 112,
    viewBox: "0 0 129 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.728 47.6826C19.1697 47.6826 7.36328 59.4931 7.36328 74.0677V78.2497C7.36328 92.8243 19.1697 104.635 33.728 104.635H93.9677C108.526 104.635 120.332 92.8243 120.332 78.2497V74.0677C120.332 59.4931 108.526 47.6826 93.9677 47.6826H33.728ZM-0.636719 74.0677C-0.636719 55.0799 14.7464 39.6826 33.728 39.6826H93.9677C112.949 39.6826 128.332 55.0799 128.332 74.0677V78.2497C128.332 97.2375 112.949 112.635 93.9677 112.635H33.728C14.7464 112.635 -0.636719 97.2375 -0.636719 78.2497V74.0677Z",
    fill: "#74D8D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.728 7.36523C19.1697 7.36523 7.36328 19.1757 7.36328 33.7503V37.9323C7.36328 52.5069 19.1697 64.3174 33.728 64.3174H93.9677C108.526 64.3174 120.332 52.5069 120.332 37.9323V33.7503C120.332 19.1757 108.526 7.36523 93.9677 7.36523H33.728ZM-0.636719 33.7503C-0.636719 14.7625 14.7464 -0.634766 33.728 -0.634766H93.9677C112.949 -0.634766 128.332 14.7625 128.332 33.7503V37.9323C128.332 56.9201 112.949 72.3174 93.9677 72.3174H33.728C14.7464 72.3174 -0.636719 56.9201 -0.636719 37.9323V33.7503Z",
    fill: "#17BEBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIso);
export default __webpack_public_path__ + "static/media/iso.466cdf91b145e9efbe274ed72053815b.svg";
export { ForwardRef as ReactComponent };